/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

import '@main';

let homeSwiperElement = document.querySelector('.c-home-swiper');

if (homeSwiperElement) {
  let homeSwiper = new Swiper('.c-home-swiper', {
    speed: 1000,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    loop: true
  });
}
